import apiClient from '../../utils/apiClient';
import {
  CreateOrderRequest,
  CreateOrderResponse,
  VerifyHypPaymentResponse,
  Order,
} from './orderModels';

/**
 * Create a new order (returns Hyp paymentUrl for credit payments)
 */
export const createNewOrder = async (
  orderData: CreateOrderRequest
): Promise<CreateOrderResponse> => {
  const response = await apiClient.post<CreateOrderResponse>('/orders', orderData, {
    timeout: 30000, // includes Hyp APISign round-trip
  });
  return response.data;
};

/**
 * Verify Hyp payment completion redirect params (server-side VERIFY)
 */
export const verifyHypPayment = async (
  redirectParams: Record<string, string>
): Promise<VerifyHypPaymentResponse> => {
  const response = await apiClient.post<VerifyHypPaymentResponse>(
    '/payments/hyp/verify',
    redirectParams
  );
  return response.data;
};

export const getOrderByNumber = async (orderNumber: string): Promise<Order> => {
  const response = await apiClient.get<{ order: Order }>(`/orders/${orderNumber}`);
  return response.data.order;
};

